import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';
// import packageJson from '../package.json';

// import * as Sentry from "@sentry/react";
// Sentry.init({
//   dsn: "https://507d5e7ab96d9e8770bce45e3ff76aca@o4510831028731904.ingest.us.sentry.io/4510832057450496",
//   // debug: true,
//   release: `web@${packageJson.version}`,
//   integrations: [
//     Sentry.consoleLoggingIntegration({ levels: ["error"] }),
//   ],

//   sampleRate: 1.0,
//   tracesSampleRate: 1.0,
// });

// (function () {
//   // 1. 获取当前 console.error 的引用 (此时它可能已经被 Unity 劫持了)
//   const currentError = console.error;

//   // 2. 只有当它还没被 Sentry 污染时才进行增强
//   if (currentError && !currentError.__SENTRY_REWRITTEN__) {
//     console.error = function (...args) {
//       // 3. 将错误手动喂给 Sentry
//       // 如果第一个参数是 Error 对象则直接传，否则拼接字符串
//       const message = args.map(arg =>
//         typeof arg === 'object' ? JSON.stringify(arg) : arg
//       ).join(' ');

//       Sentry.captureException(new Error(message));

//       // 4. 将控制权还给原来的处理器 (比如 Unity)
//       // 这样 Unity 的日志系统依然能正常工作
//       return currentError.apply(this, args);
//     };
//     // 标记一下，防止重复改写
//     console.error.__SENTRY_REWRITTEN__ = true;
//   }
// })();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
const urlParams = new URLSearchParams(window.location.search);
if (urlParams.get('pwa') != null) {
  console.log("register service worker for pwa");
  serviceWorkerRegistration.register();
} else {
  console.log("unregister service worker");
  serviceWorkerRegistration.unregister();
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
